import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TipoFirmante } from '../../models/tipo-firmante';
import { DatosEnviosService } from '../../services/datos-envios.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { Firmantes } from '../../models/firmantes';
import { FormularioEnvioService } from '../../services/formulario-envio.service';
import { TipoDestinatario } from '../../models/tipo-destinatario';
import { TipoBusqueda } from '../../models/tipo-busqueda';
import { FormArray, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';


@Component({
  selector: 'app-firmantes',
  templateUrl: './firmantes.component.html',
  styleUrls: ['./firmantes.component.css']
})
export class FirmantesComponent implements OnInit {

  tiposFirmantes: TipoFirmante[] = [];
  @Input() totalFirmantes: Firmantes[] = [];
  destinatarios: TipoDestinatario[];
  busquedas: TipoBusqueda[];
  @Input() hayCopiaBasica: number;
  busquedasInicial: TipoBusqueda[] = [];
  resetBusqueda: boolean = false;
  numeroFirmanteAdicional:number=0;

  constructor(private datosEnvioService: DatosEnviosService,
              private _snackBar: MatSnackBar,
              public formularioEnvioService: FormularioEnvioService,
              private dialog: MatDialog) { }

  ngOnChanges(changes: SimpleChanges){
    this.resetBusqueda = false;
    if (changes.hayCopiaBasica && changes.hayCopiaBasica.currentValue !== undefined) {
    if(changes.hayCopiaBasica?.currentValue>0){
      this.busquedas = [{codigo: 'documento', desc:'Documento'}];
      let firmantesForm = this.formularioEnvioService.formularioEnvio.get('firmantes') as FormArray;
      let countFirmantes: number = 0;
      firmantesForm.controls.forEach(x=> {
        let busqueda = (x as FormGroup).controls['tipoBusqueda'] as FormGroup;
        if(busqueda.controls['codigo'].value!='documento'){
          busqueda.controls['codigo'].setValue('documento');
          busqueda.controls['desc'].setValue('Documento');
          countFirmantes++;
        }
      });
      if(countFirmantes>0){
        const dialogRef = this.dialog.open(ModalMessageComponent, {
          data: {
            mensaje: `El tipo de búsqueda de uno o más firmantes ha cambiado a 'Documento' porque se ha añadido un documento copia básica.`,
            alert: true,
            informacion: true
          },
        });
      }
    }else if(changes.hayCopiaBasica?.currentValue==0 && !changes.hayCopiaBasica?.firstChange){
      this.busquedas = this.busquedasInicial;
      let firmantesForm = this.formularioEnvioService.formularioEnvio.get('firmantes') as FormArray;
      firmantesForm.controls.forEach(x=> {
        let busqueda = (x as FormGroup).controls['tipoBusqueda'] as FormGroup;
        busqueda.controls['codigo'].setValue('');
        busqueda.controls['desc'].setValue('');
      });
      this.resetBusqueda = true;
    }
  }
  }

  ngOnInit(): void {
    this.getTipoFirmantes();
    this.getTipoBusqueda();
    this.getTipoDestinatario();
  }

  get esRLT(){ return this.formularioEnvioService.formularioEnvio.controls['esRLT']}

  getTipoFirmantes(){
    this.datosEnvioService.getTipoFirmante().subscribe(
      next => {
        // this.tiposFirmantes = next;
        this.tiposFirmantes = next.filter(x=>Number(x.codigo)<104);
        this.tiposFirmantes.shift();
        this.tiposFirmantes.find(x=>x.codigo=='103').desc = 'Firmante adicional';
      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }


  recuperaClick(pastillaInfo:any){
    let infoFirmante: Firmantes = {
      orden: null,
      tipoFirmante: {codigo: '',desc: ''},
      tipoDestinatario: {codigo: '',desc: ''},
      tipoBusqueda: {codigo: '',desc: ''}
    }
    if(Number(pastillaInfo.codigo)<103){
      infoFirmante.orden= this.totalFirmantes.length+1;
      infoFirmante.tipoFirmante = {
          codigo: pastillaInfo.codigo,
          desc: pastillaInfo.desc
        }
    }else{
      let codigos = this.totalFirmantes.map(x => Number(x.tipoFirmante.codigo));
      let codigosFiltrados = codigos.filter(num => num > 102).sort((a, b) => a - b);
      let smallestMissing = 103;

      for (let codigo of codigosFiltrados) {
        if (codigo !== smallestMissing) {
            break; //no se puede usar break dentro de un forEach
        }
        smallestMissing++;
      }

      infoFirmante.orden = this.totalFirmantes.length+1,
      infoFirmante.tipoFirmante = {
          codigo: `${smallestMissing}`,
          desc: `${pastillaInfo.desc} ${smallestMissing<110?smallestMissing%10-2:smallestMissing%100-2}`
        }
    }

    let indexFirmante = this.totalFirmantes.findIndex(x => x.tipoFirmante.codigo == infoFirmante.tipoFirmante.codigo);
    if(Number(infoFirmante.tipoFirmante.codigo)>112){
      this._snackBar.open(`No se pueden añadir más de 10 firmantes adicionales`,'Cerrar', {duration: 3000});
    }else if(indexFirmante == -1){
      this.totalFirmantes = this.formularioEnvioService.addFirmante(infoFirmante)
    }else{
      this._snackBar.open(`No se puede añadir más de un '${infoFirmante.tipoFirmante.desc}'`,'Cerrar', {duration: 3000});
    }

  }

  reordenaFirmantes(){
    this.totalFirmantes.map(x => x.orden = this.totalFirmantes.indexOf(x)+1);
  }

  drop(event: CdkDragDrop<Firmantes[]>) {
      this.resetBusqueda = false;
      this.totalFirmantes = this.formularioEnvioService.getFirmantes()
      moveItemInArray(this.totalFirmantes, event.previousIndex, event.currentIndex);
      this.reordenaFirmantes();
      this.totalFirmantes = this.formularioEnvioService.updateOrdenInForm(this.totalFirmantes)
  }

  eliminarFirmante(info:any){
    this.totalFirmantes = this.formularioEnvioService.deleteFirmante(info-1)
  }

  trackByFirmante(index: number, firmante: Firmantes): string {
    return `${firmante.tipoFirmante.codigo}-${firmante.orden}`;
  }

  getTipoDestinatario(){
    return this.datosEnvioService.getTipoDestinatario().subscribe(
      next => {
        this.destinatarios = next;
      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }

  getTipoBusqueda(){
    return this.datosEnvioService.getTipoBusqueda().subscribe(
      next => {
        this.busquedas = next;
        this.busquedasInicial = [...this.busquedas];
      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }
}
